import { TripVehicleType } from 'app/constants/delegation/tripVehicleType'

export const getVehicleType = (type: number): TripVehicleType => {
  let vehicleType = TripVehicleType.NotSet

  switch (type) {
    case 0:
      vehicleType = TripVehicleType.Above35Ton
      break
    case 1:
      vehicleType = TripVehicleType.Below35Ton
      break
    case 2:
      vehicleType = TripVehicleType.Bus
      break
    case 3:
      vehicleType = TripVehicleType.Train
      break
    case 4:
      vehicleType = TripVehicleType.Ferry
      break
    case 5:
      vehicleType = TripVehicleType.Plane
      break
    case 6:
      vehicleType = TripVehicleType.MiniBus
      break
  }

  return vehicleType
}
